module.exports = __webpack_public_path__ + "media/images/xpass/landing_page/app-store-button-4c6c932087a775684030c4e1363f8e55.png";